var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-aside-heading" }, [
    _c("div", { staticClass: "product-aside-heading-top" }, [
      _c(
        "div",
        { staticClass: "product-aside-heading-pre" },
        [
          _vm.product.product_type
            ? _c("span", { staticClass: "product-aside-heading-tag" }, [
                _vm._v(_vm._s(_vm.product.product_type)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("h1", { staticClass: "product-aside-heading-heading" }, [
            _vm._v(_vm._s(_vm.product.shopify_title)),
          ]),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "product-aside-heading-like" },
        [
          _c("addToWishlist", {
            attrs: {
              id: _vm.product.shopify_id,
              title: _vm.product.shopify_title,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }